import {EventBus} from "../../../../common/ts/events/EventBus";
import * as selectComponent from "../../../../common/ts/components/core/SelectComponent";
import location from "../../../../common/ts/core/location";
import {PropertyTypeSelectedEvent} from "./events";
import {getFormDataSubmittingInFilterBar} from "../../serp/filters/filterFormData";

const PROPERTY_TYPE_FILTER_ID = `property-type-select-filter`;

function init(currentPropertyType: string) {
    selectComponent.onChangeFor(PROPERTY_TYPE_FILTER_ID, function ({name, value}) {
        const searchParamsWithCurrentPropertyType = new URLSearchParams(location.getQueryParams());
        searchParamsWithCurrentPropertyType.set(name, currentPropertyType);
        EventBus.getInstance().emit(new PropertyTypeSelectedEvent({
            name,
            value,
            formData: getFormDataSubmittingInFilterBar(),
            searchParams: searchParamsWithCurrentPropertyType,
        }));
    })
}

export default {
    init,
}
